<template>
  <el-form ref="form" label-width="130px" :model="pointInfo">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="设备设施名称" prop="deviceName">
          <el-input
            v-model="pointInfo.deviceName"
            placeholder="请输入设备设施名称"
            maxlength="50"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="设备设施编号" prop="deviceCode">
          <el-input
            v-model="pointInfo.deviceCode"
            placeholder="请输入设备设施编号"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查周期" prop="inspectionCycle">
          <el-input
            v-model="unitCycleListMap"
            placeholder="请输入排查周期"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查类型" prop="inspectionType">
          <el-select
            v-model="pointInfo.inspectionType"
            size="small"
            class="w-full"
            placeholder="请选择排查类型"
            :disabled="disabled"
            clearable
          >
            <el-option
              v-for="item in checkTypeList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="检查项目" prop="inspectionItems">
          <el-input
            type="textarea"
            v-model="pointInfo.inspectionItems"
            placeholder="请输入检查项目"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="不符合标准及情况" prop="noComplianceStandard">
          <el-input
            type="textarea"
            v-model="pointInfo.noComplianceStandard"
            placeholder="请输入不符合标准及情况"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="隐患排查内容" prop="troubleshootingContent">
          <el-input
            type="textarea"
            v-model="pointInfo.troubleshootingContent"
            placeholder="请输入隐患排查内容"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import utils from '@/components/safety/enumField/utils'

export default {
  name: 'plantask-equip-form',
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      unitCycleList: [],
      checkTypeList: [],
      pointInfo: {
        deviceName: '',
        deviceCode: '',
        inspectionCycle: null,
        inspectionType: null,
        unitCycle: null,
        inspectionItems: '',
        noComplianceStandard: '',
        troubleshootingContent: '',
      },
      areaList: [],
      jobActivityFrequencyList: [],
      jobActivityTypeList: [],
      deviceList: [],
      disabled: true,
    }
  },
  computed: {
    // 排查周期
    unitCycleListMap() {
      const name =
        this.unitCycleList.find((i) => {
          // eslint-disable-next-line eqeqeq
          return i.code == this.pointInfo.unitCycle
        })?.displayName || ''
      return !_.isNil(this.pointInfo.inspectionCycle)
        ? `${this.pointInfo.inspectionCycle}${name}`
        : null
    },
  },
  methods: {
    async getPointInfo() {
      const {
        deviceName,
        deviceCode,
        inspectionCycle,
        inspectionType,
        inspectionItems,
        noComplianceStandard,
        troubleshootingContent,
        unitCycle,
      } = this.currentRow
      this.pointInfo = {
        deviceName,
        deviceCode,
        inspectionCycle,
        inspectionType,
        inspectionItems,
        noComplianceStandard,
        troubleshootingContent,
        unitCycle,
      }
    },
  },
  mounted() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
      ],
      ['unitCycleList', 'checkTypeList'],
      this
    )
    // 获取风险点基本信息
    this.getPointInfo()
  },
}
</script>

<style lang="scss" scoped></style>
